import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/siteConfig";

export default function WhatsAppButton() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-40 bg-[#FF6B00] text-white w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center shadow-[4px_4px_0_#0A0A0A] hover:shadow-[6px_6px_0_#0A0A0A] hover:translate-x-[-2px] hover:translate-y-[-2px] transition-all ez-pulse group"
      aria-label="Chat with us on WhatsApp"
      data-testid="floating-whatsapp-btn"
    >
      <MessageCircle className="w-7 h-7" strokeWidth={2} fill="white" />
      <span className="absolute left-full ml-3 whitespace-nowrap bg-[#0A0A0A] text-white text-xs px-3 py-1.5 font-mono-ez uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us
      </span>
    </a>
  );
}
